<template>
	<button type="button" class="arrow-btn arrow-btn-back arrow-btn--gold unstyled-btn underlined" @click="handleClick">
			{{ backText }}
	</button>
</template>
<script>

export default {
	props: {
		blackArrow: {
			type: Boolean,
			default: false,
		},
		backText: {
			type: String,
			default: 'Back',
		},
	},
	emits: ['back-click'],
	computed: {
	},
	methods: {
		handleClick() {
			this.$emit('back-click');
		},
	},
	};

</script>
